import React from 'react';

const BankAccountDetails = ({ companyDetails }) => {
    return (
        <>
            {(companyDetails) &&
                <div className=" w-full pb-10 pt-0">

                    <h1 className="font-bold text-lg mb-3 px-2">Bank Account Details Info</h1>

                    <table className="custom-details-table w-full mt-0 mb-2">
                        <tbody>
                            <tr>
                                <td className="font-semibold text-base">Account Name</td>
                                <td className="px-5 text-base">{companyDetails.bank_account_name}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Account Number</td>
                                <td className="px-5 text-base">{companyDetails.bank_account_number}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Bank Name</td>
                                <td className="px-5 text-base">{companyDetails.bank?.name}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Branch Name</td>
                                <td className="px-5 text-base">{companyDetails.branch?.name}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Routing Number</td>
                                <td className="px-5 text-base">{companyDetails.bank_routing}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>}
        </>
    );
};

export default BankAccountDetails;